export const VERIFICATION_SMS_SUCCESS = 'VERIFICATION_SMS_SUCCESS';
export const VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER';
export const SAVE_NOTIFICATION = 'SAVE_NOTIFICATION';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const SEND_VERIFICATION_ERROR = 'SEND_VERIFICATION_ERROR';
export const VERIFY_PHONE_NUMBER_ERROR = 'VERIFY_PHONE_NUMBER_ERROR';
export const RESET_ERRORS = 'RESET_ERRORS';
